<template lang="html">
  <v-dialog v-model="dialogSizeWebviewExample" max-width="400" persistent max-height="300px" style="overflow-y: hidden; border-radius: 20px !important;">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text Kanit">
            <v-layout row wrap>
              <p class="mb-0">ตัวอย่างขนาดของเว็บวิว</p>
            </v-layout>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon flat @click="closeDialog">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text class="" style="height: 300px !important; overflow-x: hidden;    display: flex;">
        <v-img :src="'/static/bot component/sizewebview.jpg'" width="350"></v-img>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogSizeWebviewExample: false,
    radioGroup: null
  },
  data: () => ({
  }),
  created () {
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialogSizeWebviewExample', false)
    }
  },
  watch: {
    dialogSizeWebviewExample () {
      this.templateSelected = this.radioGroup
    }
  }
}
</script>

<style lang="css" scoped>
.Kanit {
  font-family: 'Kanit', sans-serif !important;
  word-wrap: break-word;
}
.v-img{
  margin-right: 20px;
}
.selected {
  border: #0D47A1 3px solid;
  cursor: pointer;
  border-radius: 5px;
}
.nonselect {
  cursor: pointer;
}
.buttonCancel {
  border-radius: 25px;

}
.buttonSelect {
background: #19212c !important;
    color: white;
    border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/managebot/bottommenu/dialog/size_webviewDialog.vue